import { lazy } from "react";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import {
  AUTHORIZATION,
  BUSINESS_CONSENT_FORM,
  BUSINESS_POLICY_FORM_CANCELLATION_REINSTATEMENT,
  BUSINESS_POLICY_FORMS,
} from "./Business.constants";

const BusinessCancellation = Loadable(
  lazy(() =>
    import("./BusinessCancellation/BusinessCancellation").then(
      ({ BusinessCancellation }) => ({
        default: BusinessCancellation,
      })
    )
  )
);
const BusinessPolicyForms = Loadable(
  lazy(() =>
    import("./BusinessPolicyForms").then(({ BusinessPolicyForms }) => ({
      default: BusinessPolicyForms,
    }))
  )
);
const CSIOCertificatePage = Loadable(
  lazy(() =>
    import("./CSIOCertificate/CSIOCertificatePage").then(
      ({ CSIOCertificatePage }) => ({ default: CSIOCertificatePage })
    )
  )
);
const CertificatePropertyInsurance = Loadable(
  lazy(() =>
    import("./PropertyInsuranceCertificate/PropertyInsuranceCertificate").then(
      ({ PropertyInsuranceCertificate }) => ({
        default: PropertyInsuranceCertificate,
      })
    )
  )
);
const CertificateGarageInsuranceInsurance = Loadable(
  lazy(() =>
    import("./GarageCertificate/GarageCertificate").then(
      ({ GarageCertificate }) => ({ default: GarageCertificate })
    )
  )
);
const Authorization = Loadable(
  lazy(() =>
    import("./AuthorizationForm/AuthorizationForm").then(
      ({ Authorization }) => ({
        default: Authorization,
      })
    )
  )
);
const BusinessConsentForm = Loadable(
  lazy(() =>
    import("./BusinessConsentForm/BusinessConsentForm").then(
      ({ BusinessConsentForm }) => ({
        default: BusinessConsentForm,
      })
    )
  )
);

const BusinessPolicyIntactAuthorization = Loadable(
  lazy(() =>
    import("./BusinessPolicyIntactAuthorization/BusinessPolicyIntactAuthorization").then(
      ({ BusinessPolicyIntactAuthorization }) => ({
        default: BusinessPolicyIntactAuthorization,
      })
    )
  )
);

const BusinessLossNotice = Loadable(
  lazy(() =>
    import("./BusinessPolicyForms/BusinessLossNotice").then(
      ({ BusinessLossNotice }) => ({ default: BusinessLossNotice })
    )
  )
);

export const BusinessPolicyFormsRoutes = [
  {
    path: `${BUSINESS_POLICY_FORM_CANCELLATION_REINSTATEMENT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <BusinessCancellation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${BUSINESS_POLICY_FORM_CANCELLATION_REINSTATEMENT}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <BusinessCancellation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${BUSINESS_POLICY_FORM_CANCELLATION_REINSTATEMENT}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <BusinessCancellation isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${BUSINESS_POLICY_FORMS}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessPolicyForms />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTHORIZATION}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Authorization />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTHORIZATION}/:authNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Authorization />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTHORIZATION}/duplicate/:authNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Authorization isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path:`${BUSINESS_CONSENT_FORM}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessConsentForm />
      </AuthorizedRoute>
    ),
  },

  {
    path: `${BUSINESS_CONSENT_FORM}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessConsentForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${BUSINESS_CONSENT_FORM}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessConsentForm isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessPolicyIntactAuthorization />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization/:serialNumber`,
    exact: true,        
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessPolicyIntactAuthorization />
      </AuthorizedRoute>
    ),    
  },
  {
    path: `/business-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization/duplicate/:serialNumber`,
    exact: true,  
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessPolicyIntactAuthorization isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessLossNotice />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice/:claimNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessLossNotice />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice/duplicate/:claimNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessLossNotice isDuplicate />
      </AuthorizedRoute>
    ),
  },
];
